export function CloseIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.55635 9.9707L4.31371 5.72806L5.72792 4.31385L9.97056 8.55649L14.2132 4.31385L15.6274 5.72806L11.3848 9.9707L15.6274 14.2133L14.2132 15.6276L9.97056 11.3849L5.72792 15.6276L4.31371 14.2133L8.55635 9.9707Z" />
    </svg>
  );
}
